import { useRef, useState, useEffect } from "react";
import GioiThieuLayout from "./GioiThieu/GioiThieuLayout";
import MangluoiLayout from "./MangLuoi/MangLuoiLayout";
import LichSuLayout from "./LichSu/LichSuLayout";
import "./hoahong.scss";
import { HeaderNull } from "../../../../component/HeaderNull";
import { useMediaQuery } from "react-responsive";
import { getFromlocalstorage } from "../../../../component/MaHoaDuLieu/MaHoaDuLieu";
import Notify from "../../../../component/Notify/Notify";
import Loading from "../../../../component/Loading/Loading";

const IsMobile = () => {
  return useMediaQuery({ query: "(max-width: 767px)" });
};

function HoaHongLayout() {
  const [activeTab, setActiveTab] = useState("แนะนำ");
  const [userdata, setUserdata] = useState(null);
  const [showNoti, setShowNoti] = useState(false);
  const [notiMessage, setNotiMessage] = useState("");
  const [datanguoi, setdatanguoi] = useState({});
  const hasFetched = useRef(false);
  const [loading, setLoading] = useState(false);
  const currentDomain = window.location.origin;
  const referralLink = `${currentDomain}/login?code=${userdata?.code || ""}`;
  const apiUrl = process.env.REACT_APP_API_BACKEND;
  const isMobile = IsMobile();
  const tabs = ["แนะนำ", "สมาชิก"];
  useEffect(() => {
    const data = JSON.parse(getFromlocalstorage("data_u"));
    setUserdata(data);
  }, []);

  const fetchdata = async () => {
    setLoading(false);
    try {
      const response = await fetch(`${apiUrl}/referred/${userdata.id}`);
      if (response.ok) {
        const data = await response.json();
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (userdata && !hasFetched.current) {
      fetchdata();
      hasFetched.current = true;
    }
  }, [userdata]);

  const fetchdatanguoi = async () => {
    try {
      const response = await fetch(`${apiUrl}/getsoluongf123/${userdata.id}`);
      if (response.ok) {
        const data = await response.json();
        setdatanguoi(data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (userdata) {
      fetchdatanguoi();
    }
  }, [userdata]);

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setNotiMessage("คัดลอกสำเร็จ");
      setShowNoti(true);
    });
  };
  useEffect(() => {
    if (showNoti) {
      const timer = setTimeout(() => setShowNoti(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [showNoti]);
  return (
    <>
      {notiMessage && (
        <Notify
          message={notiMessage}
          setcontent={setNotiMessage}
          type="success"
        />
      )}
      <Loading isLoading={loading} />
      {isMobile && <HeaderNull title={"ค่าคอมมิชชั่น"} link={"/usermobile"} />}
      <div
        className={`divhoahong_container ${
          isMobile ? "divhoahong_container_mobile" : ""
        } `}
      >
        <div className="tab_list">
          {tabs.map((tab) => (
            <div
              key={tab}
              className={`tab_item ${
                activeTab === tab ? "tab_item_active" : ""
              }`}
              onClick={() => setActiveTab(tab)}
            >
              <div className="tab_itemtext">{tab}</div>
            </div>
          ))}
        </div>
        <div>
          {activeTab === "แนะนำ" && (
    <GioiThieuLayout
      userdata={userdata}
      referralLink={referralLink}
      datanguoi={datanguoi}
    />
  )}
  {activeTab === "สมาชิก" && (
    <MangluoiLayout
      userdata={userdata}
      datanguoi={datanguoi}
    />
  )}
     
        </div>
      </div>
    </>
  );
}

export default HoaHongLayout;
